import AboutDetails from "../../components/AboutDetails/Index";

const About = () => {
  return <AboutDetails />;
};

export default About;
